import { useEffect, useState } from "react";
import classes from "./LoadingBar.module.scss";

const LoadingBar = ({
  progress = 0,
  isLoading = false,
  fakeLoading = false,
  speed = 200,
  maxProgress = 95,
}) => {
  const [animatedProgress, setAnimatedProgress] = useState(progress);

  useEffect(() => {
    if (fakeLoading) {
      setAnimatedProgress(0);
      const interval = setInterval(() => {
        setAnimatedProgress((prev) => {
          if (prev >= maxProgress) return maxProgress;
          return prev + 1;
        });
      }, speed);

      return () => clearInterval(interval);
    } else {
      setAnimatedProgress(progress);
    }
  }, [fakeLoading, progress, speed, maxProgress]);

  return (
    <div className={classes.loadingBar}>
      {isLoading && !fakeLoading && <div className={classes.movingBar}></div>}
      {(!isLoading || fakeLoading) && (
        <div
          className={classes.bar}
          style={{ width: `${animatedProgress}%` }}
        ></div>
      )}
    </div>
  );
};

export default LoadingBar;
